module.exports = __webpack_public_path__ + "media/images/loghi/app_store_badge-d71a027e6909c835b677875118e293ea.svg";